import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";

const FAQS = [
    {
        q: "Bila webinar berlangsung?",
        a: "Setiap Isnin dan Selasa, 8:30 malam hingga 10:00 malam.",
    },
    {
        q: "Di mana webinar dijalankan?",
        a: "Secara online melalui Zoom.",
    },
    {
        q: "Adakah webinar sesuai untuk beginner?",
        a: "Ya, webinar ini memberi tumpuan kepada pembelajaran asas teknik Engulfing.",
    },
    {
        q: "Macam mana nak join?",
        a: "Klik PM ADMIN TO JOIN untuk menghubungi admin Telegram, atau isi borang pendaftaran di website.",
    },
];

const FAQ = () => (
    <section data-testid="faq-section" className="relative py-24 md:py-32">
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal delay={0.05} className="flex flex-col items-center">
                <p className="text-center font-mono text-[11px] uppercase tracking-[0.25em] text-neon">
                    Soalan lazim
                </p>
                <h2 className="mt-5 text-center font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
                    ADA SOALAN? <span className="text-duo-grad">JAWAPANNYA</span>{" "}
                    DI SINI
                </h2>
            </Reveal>

            <Reveal delay={0.1} className="mt-12 flex justify-center">
                <Accordion
                    type="single"
                    collapsible
                    className="w-full max-w-3xl"
                >
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i + 1}`}
                            className="border-white/10"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i + 1}`}
                                className="py-6 text-left font-display text-base font-bold text-white transition-colors duration-300 hover:text-neon hover:no-underline md:text-lg"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-sm leading-relaxed text-white/65 md:text-base">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);

export default FAQ;
